import { Box, Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { FC, useCallback } from "react";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import api, { STATUS_CODE } from "src/framework/providers/api";
import { Projeto } from "../../types";
import { notifierStore } from "src/framework/store/NotifierStore";

interface ModalAtualizarEntregaParams {
    open: boolean;
    closeModal: () => void;
    projeto?: Projeto;
}

const FALLBACK_MENSAGEM_ERRO = "Ocorreu um erro ao buscar a entrega";

export const ModalAtualizarEntrega: FC<ModalAtualizarEntregaParams> = ({ open, closeModal, projeto }) => {
    const onConfirm = useCallback(async () => {
        if (!projeto?.codigo_venda) return;

        const result = await api.post({
            url: "/vendas/pedidos/rastreamentos/buscar",
            data: { codigo_venda: [projeto.codigo_venda] }
        })

        closeModal();

        if (result.statusCode !== STATUS_CODE.OK) {
            const mensagemErro = Array.isArray(result.message) ? result.message.length > 0 && result.message.join(", ") : result.message;

            notifierStore.setNotifier({
                title: "Atenção",
                content: mensagemErro || FALLBACK_MENSAGEM_ERRO,
                onClose: () => notifierStore.setOpen(false),
                timeOut: 4000,
            })
            notifierStore.setOpen(true);
            return;
        }

        notifierStore.setNotifier({
            title: "Sucesso",
            content: result.data?.message,
            onClose: () => notifierStore.setOpen(false),
            timeOut: 4000,
        })
        notifierStore.setOpen(true);
    }, [closeModal, projeto?.codigo_venda])

    return (
        <Dialog
            open={open}
            onClose={closeModal}
            maxWidth='md'
        >
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid container size={12}>
                        <Grid size={12}>
                            <Box component={"span"}>Deseja atualizar a entrega do projeto {projeto?.codigo_venda} ?</Box>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <FlatButton
                    color="inherit"
                    variant="contained"
                    disableElevation
                    text="Fechar"
                    onClick={closeModal}
                />
                <FlatButton
                    color="primary"
                    variant="contained"
                    disableElevation
                    text="Confirmar"
                    onClick={onConfirm}
                />
            </DialogActions>
        </Dialog>
    )
}
